<template>
    <div class="content_div">
        <el-card>
            <!--商品-->
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <el-form-item label="送达日期">
                    <el-date-picker
                        class="input_class"
                        v-model="query.days"
                        type="date"
                        placeholder="请选择送达日期"
                        value-format="yyyy-MM-dd"
                        clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="订单时段">
                    <el-select class="input_class" v-model="query.type" placeholder="请选择订单时段" clearable>
                        <el-option label="早餐" value="1"></el-option>
                        <el-option label="午餐" value="2"></el-option>
                        <el-option label="晚餐" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
            </el-form>

            <el-table
                :data="list"
                border>
                <el-table-column type="index" label="编号" width="80"/>
                <el-table-column prop="nickname" label="操作人"/>
                <el-table-column prop="days" label="送达日期"/>
                <el-table-column prop="num" label="送达数量"/>
                <el-table-column prop="goodsType" label="订单时段" width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type===0">不在用餐时间</el-tag>
                        <el-tag v-if="scope.row.type===1">早餐</el-tag>
                        <el-tag type="danger" v-if="scope.row.type===2">午餐</el-tag>
                        <el-tag type="success" v-if="scope.row.type===3">晚餐</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="送达时间"/>
            </el-table>
        </el-card>


        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close(0)" width="30%">
            <el-form label-width="150px" :model="data" ref="data" :rules="rules">
                <el-form-item label="地址" prop="name">
                    <el-input class="input_class" v-model="data.name" maxlength="30" auto-complete="off" placeholder="请输入地址"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding-right: 10%;">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {reqDeleteAddressById, reqInsertAddress, reqListAddress, reqUpdateAddress} from "../../../api/core/Address";
import {reqListDelivery} from "@/api/core/Users";

export default {
    name: "Address",
    async created() {
        await this.load();
    },
    data() {
        return {
            query: {
                currentPage: 1,
                pageSize: 100
            },
            list: [],
            total: 0,
            isShowDialogFlag: false,
            data: {},
            rules: {
                name: [
                    {required: true, message: '请输入地址', trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        async load() {
            this.list = [];
            let data = await reqListDelivery(this.query);
            this.list = data.records;
            this.total = data.total;
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async close() {
            this.isShowDialogFlag = false;
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.data.type = 2;
                    let result = this.data.id !== null ? await reqUpdateAddress(this.data) : await reqInsertAddress(this.data);
                    await this.close();
                    await this.load();
                    this.$message.success("操作成功");
                } else {
                    return false;
                }
            });
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {id: null, pid: null, name: null, sort: 1};
            } else if (type === 1) {
                this.data = {id: null, pid: row.id, name: null, sort: 1};
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteAddressById({id: id});
                this.$message.success("操作成功");
                this.query.current = 1
                await this.load();
            });
        },
    }
}
</script>
